import { useDeleteStore } from '../../hooks';
import { EnvironmentDeleteModalView } from '../../components/EnvironmentDeleteModalView';

export const EnvironmentDeleteModal = () => {
  const deleteStore = useDeleteStore();

  return <EnvironmentDeleteModalView {...deleteStore} />;
};
